import { RootAction } from 'store/state';
import { SET_MUTATION_RESPONSE } from 'store/state/mutationsResponse/types';
import { MutationType } from './apiService/types';
import { put, select, takeLatest } from 'redux-saga/effects';
import * as Types from 'store/state/realEstateOffice/types';
import { createAgentAction, updateAgentAction } from 'store/state/realEstateOffice/actions';
import { mutate, SetMutationResponseAction } from 'store/state/mutationsResponse/actions';
import { navigateTo } from 'store/state/router/actions';
import { Route } from 'config/routes';
import { setToastMessage } from 'store/state/app/actions';
import { agentIdSelector } from 'store/state/domainData/selectors';

const updateAgentMutationPattern = (action: RootAction) => (
  action.type === SET_MUTATION_RESPONSE && action.mutationType === MutationType.UpdateRealEstateAgent
);

const createAgentMutationPattern = (action: RootAction) => (
  action.type === SET_MUTATION_RESPONSE && action.mutationType === MutationType.CreateRealEstateAgent
);

function* updateAgentWorker(action: ReturnType<typeof updateAgentAction>) {
  const { payload: { agent } } = action;

  yield put(mutate({
    mutationType: MutationType.UpdateRealEstateAgent,
    meta: {
      variables: {
        agent,
      },
    },
  }));
}

function* createAgentWorker(action: ReturnType<typeof createAgentAction>) {
  const { payload: { agent } } = action;

  yield put(mutate({
    mutationType: MutationType.CreateRealEstateAgent,
    meta: {
      variables: {
        agent,
      },
    },
  }));
}

function* createAgentResponseWorker(action: SetMutationResponseAction<MutationType.CreateRealEstateAgent>) {
  if (action.meta.response.data && action.meta.response.data.publicCreateRealEstateAgent) {
    yield put(navigateTo(Route.OfficeStaffPage));
  }
  else yield put(setToastMessage({ term: 'createAgent.submit.errorMessage', type: 'error' }));
}

function* updateAgentResponseWorker(action: SetMutationResponseAction<MutationType.UpdateRealEstateAgent>) {
  if (action.meta.response.data && action.meta.response.data.publicUpdateRealEstateAgent) {
    const agentId: string = yield select(agentIdSelector);
    const isOwnProfile = agentId === action.meta.response.data.publicUpdateRealEstateAgent.agentId;
    yield put(navigateTo(isOwnProfile ? Route.AgentConsoleHomePage : Route.OfficeStaffPage));
    yield put(setToastMessage({ term: 'officeProfile.submit.successMessage', type: 'success' }));
  }
  else yield put(setToastMessage({ term: 'officeProfile.submit.errorMessage', type: 'error' }));
}

export function* realEstateAgentWatcher() {
  yield takeLatest(Types.UPDATE_AGENT, updateAgentWorker);
  yield takeLatest(Types.CREATE_AGENT, createAgentWorker);
  yield takeLatest(updateAgentMutationPattern, updateAgentResponseWorker);
  yield takeLatest(createAgentMutationPattern, createAgentResponseWorker);
}
